import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import ConfigurationsSoftSkillsLevelsService from "../../../../services/api/configurations/ConfigurationsSoftSkillsLevels.service";
import { RefreshReactQuery } from "../../../../constants/AppConstants";
import { useNotification } from "../../../notification.hook";
import {
  DATA_SAVED_SUCCESS_LABEL,
  ERROR_LABEL,
  ERROR_MESSAGE_LABEL,
} from "../../../../constants/Dictionary";
import { UpdateSoftSkillsLevelsConfig } from "../../../../types/api/configurations.type";
import { useEffect } from "react";

const MANAGE_CONFIG_SKILLS_LEVELS_QUERY_KEY = "get-config-soft-skills-levels";

export const useManageSkillLevels = (configYear: number) => {
  const { notification } = useNotification();
  const { data, isFetching, isError } = useQuery({
    queryKey: [MANAGE_CONFIG_SKILLS_LEVELS_QUERY_KEY, configYear],
    queryFn: () => ConfigurationsSoftSkillsLevelsService.list(),
    staleTime: RefreshReactQuery.MODERATE,
  });

  useEffect(() => {
    if (isError) {
      notification.error(ERROR_LABEL, ERROR_MESSAGE_LABEL);
    }
  }, [isError]);

  return { data, isFetching };
};

export const useUpdateManageSkillLevels = () => {
  const { notification } = useNotification();
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationKey: ["update-manage-skill-levels"],
    mutationFn: (result: UpdateSoftSkillsLevelsConfig) =>
      ConfigurationsSoftSkillsLevelsService.update(result),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [MANAGE_CONFIG_SKILLS_LEVELS_QUERY_KEY],
      });
      notification.success(DATA_SAVED_SUCCESS_LABEL, undefined, "toast");
    },
    onError: (error) => {
      console.error(`errore updating soft skills levels config: ${error}`);
      notification.error(ERROR_LABEL, ERROR_MESSAGE_LABEL);
    },
  });

  return { mutate, isPending };
};
